module.exports = __webpack_public_path__ + "img/pic_202493.aded935f.jpg";